import { c as _c } from "react/compiler-runtime";
import { fetcher } from "@website/fetcher/fetcher";
import { useFetcherV2 } from "@website/fetcher/use-fetcherV2";
import { useLoginStatus } from "@website/hooks/auth-manager";
import { GetBalanceResponseTypes } from "./types";
export const getBalanceApiURL = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/wallet/v1/users/balance`;
export const useGetBalance = () => {
  const $ = _c(8);
  const {
    isLoggedIn
  } = useLoginStatus();
  let t0;
  if ($[0] !== isLoggedIn) {
    t0 = {
      queryFn: _temp2,
      enabled: isLoggedIn
    };
    $[0] = isLoggedIn;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: data_0,
    isLoading,
    error
  } = useFetcherV2(t0);
  let t1;
  if ($[2] !== data_0) {
    t1 = data_0 || {
      balance: 0,
      creditLimit: 0,
      ledgerBalance: 0
    };
    $[2] = data_0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== error || $[5] !== isLoading || $[6] !== t1) {
    t2 = {
      isLoadingGetBalance: isLoading,
      balance: t1,
      isBalanceError: error
    };
    $[4] = error;
    $[5] = isLoading;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
function _temp(t0) {
  const {
    data
  } = t0;
  return data as GetBalanceResponseTypes;
}
function _temp2() {
  return fetcher({
    url: getBalanceApiURL
  }).then(_temp);
}